export default __webpack_public_path__ + "static/play-store-ecf10130491ecf2fae3376dc74106326.png";